<template>
  <IconLucideAppWindow />
</template>
